<template>
	<div style=" display: flex; justify-content: center;"
	:style="(windowWidth > 1000) ? 'height: 150px;' : '' "
	>
		<headMenuLg class="position-fixed w-100" v-if="windowWidth > 1000 && chechRole()" style="z-index: 1000;" />
		<headMenuSm v-if="windowWidth <= 1000" />
	</div>
</template>

	<script> 
		import headMenuLg from  "./headMenuLg.vue";
		import headMenuSm from  "./headMenuSm.vue";
		export default {
			name: 'headMenu',
			data(){
				return {
					baseurl: window.baseurl,
					formatImage: ["jpg", "jpeg", "png", "gif"],
					formatDocs: ["jpg", "jpeg", "png", "pdf"],
					mgt: false,
					degrees: [],
				}
			},
			components: {
				headMenuLg,
				headMenuSm,
			},
			mounted(){
				window.window.$('link[rel=canonical]').attr("href", window.location.href.replace("//", "//www."));



				document.getElementById("loader").style.display = "none";
				document.getElementById("app").style.display = "block";
				document.getElementById("app").style.background = "#fffcf7";


				document.body.scrollTop = 0;
				if(this.$localStorage.get('mobile') == null || this.$route.query.mobile != undefined){
					(this.$route.query.mobile == undefined) ? this.$localStorage.set('mobile', 0) : this.$localStorage.set('mobile', 1);
				}
				this.loader();
			},
			methods:{
				chechRole(){
					let user = this.$localStorage.get('user');
					if(user == null){
							return true;
					}else if(user.username.role != 3){
							return true;
					}else{
							return false;
					}
				},
				//____________________________________________________________________
				loader(THIS=this){
				}
			}
		}
	</script>
<style>
	@import "../css/templatemo-main.css";
	@import "../css/animate.css";
	@import "../assets/style/style.css";
</style>
